import { useSetRecoilState } from "recoil";
import {CustomerAtom} from '../../atoms/customerAtom';
import {Customer} from '../../providers/customer/types';
import { useRecoilState } from 'recoil';


export const useSetCustomer = (): ((customer : Customer)=> void) => {
  const setCustomer = useSetRecoilState(CustomerAtom);

  return (customer: Customer) => {
    setCustomer(customer);
  }
}